import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import './faq.css';

class Faq extends Component {

    render() {
        const { t } = this.props;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('faq-meta-title')}</title>
                    <meta name="title" content={t('faq-meta-title')} />
                    <meta name="description" content={t('faq-meta-description')} />
                    <meta name="keywords" content={t('faq-meta-keywords')} />
                </MetaTags>
                <div id="div-faq">
                    <div className="faq-header">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className="faq-header-text">{t('faq-title')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="faq-content">
                        <div className="container-fluid d-flex justify-content-center">
                            <div className="col-12 col-md-10">
                                <div className="faq-content-headline">{t('faq-headline-1')}</div>
                                <div className="faq-content-question">{t('faq-question-1')}</div>
                                <div className="faq-content-answer">{t('faq-answer-1-1')}<strong>{t('faq-answer-1-2')}</strong>{t('faq-answer-1-3')}</div>
                                <div className="faq-content-headline">{t('faq-headline-2')}</div>
                                <div className="faq-content-question">{t('faq-question-2')}</div>
                                <div className="faq-content-answer">{t('faq-answer-2')}</div>
                                <div className="faq-content-question">{t('faq-question-3')}</div>
                                <div className="faq-content-answer">{t('faq-answer-3')}</div>
                                <div className="faq-content-question">{t('faq-question-4')}</div>
                                <div className="faq-content-answer">{t('faq-answer-4')}</div>
                                <div className="faq-content-headline">{t('faq-headline-3')}</div>
                                <div className="faq-content-question">{t('faq-question-5')}</div>
                                <div className="faq-content-answer">{t('faq-answer-5')}</div>
                                <div className="faq-content-question">{t('faq-question-6')}</div>
                                <div className="faq-content-answer">{t('faq-answer-6')}</div>
                                <div className="faq-content-question">{t('faq-question-7')}</div>
                                <div className="faq-content-answer">{t('faq-answer-7')}</div>
                                <div className="faq-content-headline">{t('faq-headline-4')}</div>
                                <div className="faq-content-question">{t('faq-question-8')}</div>
                                <div className="faq-content-answer">{t('faq-answer-8')}</div>
                                <div className="faq-content-question">{t('faq-question-9')}</div>
                                <div className="faq-content-answer">{t('faq-answer-9')}</div>
                                <div className="faq-content-question">{t('faq-question-10')}</div>
                                <div className="faq-content-answer">{t('faq-answer-10')}</div>
                                <div className="faq-content-question">{t('faq-question-11')}</div>
                                <div className="faq-content-answer">{t('faq-answer-11')}</div>
                                <div className="faq-content-question">{t('faq-question-12')}</div>
                                <div className="faq-content-answer">{t('faq-answer-12')}</div>
                                <div className="faq-content-question">{t('faq-question-13')}</div>
                                <div className="faq-content-answer">{t('faq-answer-13')}</div>
                                <div className="faq-content-question">{t('faq-question-14')}</div>
                                <div className="faq-content-answer">{t('faq-answer-14')}</div>
                                <div className="faq-content-question">{t('faq-question-15')}</div>
                                <div className="faq-content-answer">{t('faq-answer-15')}</div>
                                <div className="faq-content-question">{t('faq-question-16')}</div>
                                <div className="faq-content-answer">{t('faq-answer-16-1')}<a href={t('faq-answer-16-2')} target="_blank" rel="noopener noreferrer" className="no_border normal_link">{t('faq-answer-16-2')}</a>{t('faq-answer-16-3')}</div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Faq);



// WEBPACK FOOTER //
// ./src/components/pages/faq.js